/**
 * @generated SignedSource<<c8d6e9c5d260e5b6d72d26e11b370d17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EpisodesPageTopicsQuery$variables = Record<PropertyKey, never>;
export type EpisodesPageTopicsQuery$data = {
  readonly topics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly episodeCount: number;
        readonly id: string;
        readonly name: string;
        readonly slug: string;
      };
    }>;
  };
};
export type EpisodesPageTopicsQuery = {
  response: EpisodesPageTopicsQuery$data;
  variables: EpisodesPageTopicsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "TopicConnection",
    "kind": "LinkedField",
    "name": "topics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TopicEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "episodeCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "topics(first:100)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EpisodesPageTopicsQuery",
    "selections": (v0/*: any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EpisodesPageTopicsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f3e1064608b43e3e2dd79bfa95270138",
    "id": null,
    "metadata": {},
    "name": "EpisodesPageTopicsQuery",
    "operationKind": "query",
    "text": "query EpisodesPageTopicsQuery {\n  topics(first: 100) {\n    edges {\n      node {\n        id\n        slug\n        name\n        episodeCount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da67c8f939e269293299867e90ee6468";

export default node;
